export enum DocumentStatus {
    READY = 'ready',
    PROCESSING = 'processing',
    ERROR = 'error',
    QUEUED = 'queued',
}
